import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActivePage } from "../features/navigation/navigationSlice";
import { ROUTE_TO_PAGE_NAME } from "../constants/routeUrls";

const RouteWatcher = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const path = location.pathname;
    for (const { pattern, pageName } of ROUTE_TO_PAGE_NAME) {
      if (matchPath(pattern, path)) {
        dispatch(setActivePage(pageName));
        return;
      }
    }
    // No match: preserve existing state for unmapped routes
  }, [location, dispatch]);

  return null;
};

export default RouteWatcher;
